import {IModel} from "maps-angular-components";

export class CarteiraFilter {
  constructor(public cnpj?: string, public nomeCompleto?: string, public ativa?: boolean, public auto ?: boolean) {
  }
}

export class CarteiraAutocompleteModel implements IModel {

  constructor(obj?: CarteiraAutocompleteModel)
  {
    this.id = obj?.id;
    this.nome = obj?.nome;
    this.descricao = obj?.descricao;
    this.type = obj?.type;
  }


  id: string;
  descricao: string;
  nome: string;
  type: 'CARTEIRA' | 'GRUPO' | null;


  getId() {
    return this.id;
  }

  getName() {
    return this.nome;
  }

  equals(obj: IModel) {
    return obj.getId() == obj.getId()
  }

  toJSON() {
    return Object.assign(this);
  }
}

export class GrupoCarteira {
  nome: string;
  carteiras: Carteira[];
}

export interface CarteiraDTO {
  id: string;
  idAtivo: string;
  nome: string;
  name: string;
  nomeCompleto: string;
  dataConstituicao: string;
  cnpj: string;
  admin: string;
  gestor: string;
  grupo: string;
  auto: boolean;
  grupoEconomicoAdmin: string;
  grupoEconomicoGestor: string;
  ativa: boolean;
  statusProcessamento: string;
  dataUltimoProcessamento: Date;
}
export class Carteira implements IModel {
  id: string;
  idAtivo: string;
  nome: string;
  name: string;
  nomeCompleto: string;
  dataConstituicao: string;
  cnpj: string;
  admin: string;
  gestor: string;
  grupo: string;
  auto: boolean;
  grupoEconomicoAdmin: string;
  grupoEconomicoGestor: string;
  ativa: boolean;
  statusProcessamento: string;
  dataUltimoProcessamento: Date;
  cnpjFormatado: string;

  constructor(obj?: CarteiraDTO)
  {
    this.id = obj?.id;
    this.nome = obj?.nome;
    this.name = obj?.name;
    this.cnpj = obj?.cnpj;
    this.idAtivo = obj?.idAtivo;
    this.dataUltimoProcessamento = obj?.dataUltimoProcessamento;
  }

  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }

  equals(obj: IModel) {
    return obj.getId() == obj.getId()
  }

  toJSON() {
    return Object.assign(this);
  }
}

export class CarteiraGravarTodos {

  public nomeOrCnpj: string;
  public nomeCompleto: string;
  public ativa: boolean;
  public auto: boolean;
  public shouldAtivar: boolean;
  public shouldAuto: boolean;
}
